import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { GoodsPhoto } from '../../js/ComponentManager'
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';
import "swiper/css";
import 'swiper/css/thumbs';

/* 개발담당:양유빈
 * 화면기능:스와이퍼 도매
 * 세부설명:
*/

export class SwiperWhole extends Component {
    static displayName = SwiperWhole.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: { ...this.DataObject.ContentConmgr },
            WholeList: [],
            Bgcolor: ""
        };
    }

    //초기화
    componentDidMount() {
        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        if (ContentConmgr !== null) {
            this.setState({ ContentConmgr: ContentConmgr }, () => {
                this.CallSwiperGoodsList();
            });
           
        }
    }
    DataObject = {
        ContentConmgr: {
            mgr_no: "",
            title: "",
            cntt_tye: "",
            fltr_tye: "",
            ui_tye: "",
            width_cnt: "",
            len_cnt: "",
            tab_use_yn: ""  //스와이프에서 탭은 미적용
        }
    }
    CallSwiperGoodsList = async () => {
        try {

            const Data = await Big3Common.Post(`api/AdMgr/HomeAd/GetMainSettingList`,
                {
                    mgr_no: this.state.ContentConmgr.mgr_no,
                    fltr_tye: this.state.ContentConmgr.fltr_tye
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const multiDataTable = JSON.parse(Data.multiDataTable);
                const Bgcolor = multiDataTable.bgcolor;
                const WholeList = multiDataTable.goodsList;
                this.setState({
                    WholeList: WholeList,
                    Bgcolor: Bgcolor
                });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("componentDidMount", e);
        }
    }
    WholeBoxrender() {
        const WholeList = this.state.WholeList;
        const slidersCount = Big3Common.WebConfig.SlidersCount;
        return (
            <Swiper watchSlidesProgress={true} slidesPerView={slidersCount} className="recent_poroducts row row-cols-3 no_line">
                <div className="new_shop_box">
                    {
                        WholeList.map((list, idx) =>
                            <SwiperSlide key={idx}>
                                <Link to={`/Search/Goods/Index?Uid=${list.uid}`}>
                                    <GoodsPhoto className="m_shop_img" ImageSrc={list.img_220}
                                        BackGround={true}
                                        SimilarityYn="Y"
                                    />
                                </Link>
                                <div className="m_shop_name">{list.whole_name}</div>
                                <div className="m_shop_adress">{`${list.bld_name} ${list.flr_name}층 ${list.whole_no_name}호` }</div>
                            </SwiperSlide>
                        )}
                </div>
                <SwiperSlide>
                    {/* 공백*/}
                </SwiperSlide>
            </Swiper>
        )
    }
    render() {
        const WholeList = this.state.WholeList;
        if (WholeList.length === 0) return;
        const Css = `main_content ${this.state.Bgcolor}`
        return (
            <div className={Css} key={`${this.state.ContentConmgr.mgr_no}_${this.index}`}>
                <div className="rt_main_title_box">
                    <div className="title2">{Big3Common.Util.GetContentState(this.state.ContentConmgr, "title", "")}</div>
                </div>
                <div className="today_poroducts row row-cols-3 ">
                    {this.WholeBoxrender(WholeList)}
                </div>
            </div>
        );
    }
}
